import React from 'react';
import LeadsPage from './LeadsPage';

const Leads = () => {
  return <LeadsPage />;
};

export default Leads;
